import React, { useState, useRef, useEffect } from 'react';
import { Tooltip } from 'react-tooltip';

function TooltipWrapper(props) {
	const [isOpen, setIsOpen] = useState(false);
	const tooltipRef = useRef(null);

	const handleClickOutside = (event) => {
		if ( tooltipRef.current && ! tooltipRef.current.contains(event.target) ) {
			setIsOpen(false);
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside);

		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, []);

	return (
		<span
			className='d-inline-flex align-self-center'
			ref={tooltipRef}
			data-tooltip-id={props.tooltipId}
			data-tooltip-content={props.tooltipContent}
			onClick={() => setIsOpen(!isOpen)}
		>
			<i className="icon-tooltip"></i>
			<Tooltip
				id={props.tooltipId}
				openOnClick="true"
				closeOnScroll="true"
				isOpen={isOpen}
			/>
		</span>
	);
}

export default TooltipWrapper;
